import { isVue3 } from '../vue';
export var getInstanceFromDirective = function getInstanceFromDirective(vnode, bindings) {
  return isVue3 ? bindings.instance : vnode.context;
};


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/utils/get-instance-from-directive.js
// module id = h0VS
// module chunks = 5